import { render, staticRenderFns } from "./ptjs.vue?vue&type=template&id=6f4653c0"
import script from "./ptjs.vue?vue&type=script&lang=js"
export * from "./ptjs.vue?vue&type=script&lang=js"
import style0 from "./ptjs.vue?vue&type=style&index=0&id=6f4653c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports